webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_message_board__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_reward_qr_code__ = __webpack_require__(56);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    messageBoard: __WEBPACK_IMPORTED_MODULE_3__modules_message_board__["a" /* default */],
    rewardQRCode: __WEBPACK_IMPORTED_MODULE_4__modules_reward_qr_code__["a" /* default */]
  },
  strict: debug,
  middlewares: debug ? [__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default()()] : []
}));

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHOW_MESSAGE_BOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HIDE_MESSAGE_BOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_REWARD_QR_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDE_REWARD_QR_CODE; });

var SHOW_MESSAGE_BOARD = '显示留言板';

var HIDE_MESSAGE_BOARD = '隐藏留言板';

var SHOW_REWARD_QR_CODE = '显示打赏二维码';

var HIDE_REWARD_QR_CODE = '隐藏打赏二维码';

/***/ }),
/* 13 */
/***/ (function(module, exports) {


var browser = {
  versions: function () {
    var ua = navigator.userAgent;
    return {
      trident: ua.indexOf('Trident') > -1,
      presto: ua.indexOf('Presto') > -1,
      webKit: ua.indexOf('AppleWebKit') > -1,
      gecko: ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') === -1,
      mobile: !!ua.match(/AppleWebKit.*Mobile.*/),
      ios: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      android: ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1,
      iPhone: ua.indexOf('iPhone') > -1,
      iPad: ua.indexOf('iPad') > -1,
      webApp: ua.indexOf('Safari') === -1,
      weixin: ua.indexOf('MicroMessenger') > -1,
      qq: ua.match(/\sQQ/i) === ' qq',
      chrome: ua.indexOf('Chrome') > -1,
      mac: ua.indexOf('Mac') > -1 };
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};

module.exports = browser;

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LABEL_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAGES; });

var LABELS = [{
  name: 'vue',
  style: {
    color: '#009966',
    fontSize: '24px'
  }
}, {
  name: 'html',
  style: {
    color: '#003399',
    fontSize: '22px'
  }
}, {
  name: 'html5',
  style: {
    color: '#e84c1a',
    fontSize: '20px'
  }
}, {
  name: 'javascript',
  style: {
    color: '#CC0033',
    fontSize: '22px'
  }
}, {
  name: 'css',
  style: {
    color: '#FF9900',
    fontSize: '20px'
  }
}, {
  name: 'css3',
  style: {
    color: '#27a7e2',
    fontSize: '20px'
  }
}, {
  name: 'photoshop',
  style: {
    color: '#2a2659',
    fontSize: '18px'
  }
}, {
  name: 'stylus',
  style: {
    color: '#2a4f84',
    fontSize: '16px'
  }
}, {
  name: 'es6/es7',
  style: {
    color: '#f5d42d',
    fontSize: '18px'
  }
}, {
  name: 'jquery',
  style: {
    color: '#555555',
    fontSize: '16px'
  }
}, {
  name: 'zepto',
  style: {
    color: '#ba49fd',
    fontSize: '16px'
  }
}, {
  name: 'react-native',
  style: {
    color: '#2cd5ff',
    fontSize: '18px'
  }
}, {
  name: 'echarts',
  style: {
    color: '#a9334c',
    fontSize: '18px'
  }
}, {
  name: 'node.js',
  style: {
    color: '#92c520',
    fontSize: '14px'
  }
}, {
  name: 'github',
  style: {
    color: '#181617',
    fontSize: '18px'
  }
}, {
  name: 'webpack',
  style: {
    color: '#6d94d9',
    fontSize: '18px'
  }
}];

var POSITIONS = [{
  left: '10px',
  top: '80px'
}, {
  left: '-17px',
  top: '-80px'
}, {
  left: '-30px',
  top: '140px'
}, {
  left: '75px',
  top: '-40px'
}, {
  left: '70px',
  top: '50px'
}, {
  left: '90px',
  top: '20px'
}, {
  left: '-120px',
  top: '-3px'
}, {
  left: '-120px',
  top: '-55px'
}, {
  left: '-70px',
  top: '55px'
}, {
  left: '70px',
  top: '-110px'
}, {
  left: '70px',
  top: '110px'
}, {
  left: '-100px',
  top: '-120px'
}, {
  left: '-100px',
  top: '120px'
}, {
  left: '-80px',
  top: '-30px'
}, {
  left: '-120px',
  top: '30px'
}, {
  left: '100px',
  top: '-10px'
}];

var LABEL_DETAILS = {
  'vue': {
    message: '熟练掌握vue及其全家桶<br>从2015年使用至今<br>熟悉vue1.0以及2.0以及其差异<br>能独立开发可拓展可维护组件<br>已经有一个相对完备的vue组件库'
  },
  'html': {
    message: '熟练掌握html各种常用标签<br>认识的已经足够日常开发使用<br>已了解标签语意化 并在日常开发中养成习惯<br>已习惯编写结构整洁语意清的代码'
  },
  'html5': {
    message: '熟练掌握html5常用知识点<br>绝大部分没有太大兼容性问题的知识已经掌握得相对比较好'
  },
  'javascript': {
    message: '熟练运用<br>基础相对扎实, 熟练使用函数节流,防抖等技巧<br>能不使用任何库开发项目<br>写过几个纯原生的工具库, 并且还在维护, 一直有人在使用'
  },
  'css': {
    message: '熟练掌握<br>能熟练使用css进行各种布局<br>熟悉各伪元素使用<br>理解BFC'
  },
  'css3': {
    message: '熟练掌握<br>了解常用属性的使用方法和兼容性'
  },
  'photoshop': {
    message: '掌握前端常用的ps技巧<br>能进行简单的图片编辑<br>能满足前端日常开发需要'
  },
  'stylus': {
    message: '基本掌握<br>习惯使用stylus编写样式, 但不依赖'
  },
  'es6/es7': {
    message: '基本掌握<br>项目中习惯使用es6+babel形式开发'
  },
  'jquery': {
    message: '基本掌握<br>能读懂jq写的程序<br>没有使用jq开发项目的习惯, 不依赖jq'
  },
  'zepto': {
    message: '基本掌握<br>能读懂能简单使用<br>但是没有用其开发项目的习惯'
  },
  'react-native': {
    message: '了解<br>曾用react-native + mobx的形式开发过简单的app'
  },
  'echarts': {
    message: '基本掌握<br>以往工作曾大量使用<br>熟悉其使用方法'
  },
  'node.js': {
    message: '了解<br>能使用Node编写简单restful接口<br>能编写自己的命令行工具<br>能进行基本的文件操作<br>能编写简单爬虫'
  },
  'github': {
    message: '基本掌握<br>自己的项目都用github托管<br>熟悉版本控制流程'
  },
  'webpack': {
    message: '基本掌握<br>日常开发都是用webpack搭建项目'
  }
};

var MESSAGES = [{
  title: '出生年月',
  content: '1991.12',
  icon: '&#xf010f;'
}, {
  title: '学历',
  content: '大学本科',
  icon: '&#xe607;'
}, {
  title: '籍贯',
  content: '广东汕头',
  icon: '&#xe619;'
}, {
  title: '目前所在地',
  content: '广东广州',
  icon: '&#xe617;'
}, {
  title: '电子邮箱',
  content: '530784837@qq.com',
  icon: '&#xe642;'
}, {
  title: 'github',
  content: 'https://github.com/qgh810',
  icon: '&#xe735;'
}];

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animate_text_animate_text__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animate_text_animate_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__animate_text_animate_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__button_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_menu_button__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_menu_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__button_menu_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__book_book__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__book_book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__book_book__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logo_logo__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logo_logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__logo_logo__);








var components = {
  AnimateText: __WEBPACK_IMPORTED_MODULE_0__animate_text_animate_text___default.a,
  HButton: __WEBPACK_IMPORTED_MODULE_1__button_button___default.a,
  MenuButton: __WEBPACK_IMPORTED_MODULE_2__button_menu_button___default.a,
  Book: __WEBPACK_IMPORTED_MODULE_3__book_book___default.a,
  Logo: __WEBPACK_IMPORTED_MODULE_4__logo_logo___default.a
};

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (install.installed) return;

  for (var name in components) {
    Vue.component(name, components[name]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_index__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_home_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_works_index__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_works_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_works_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_collections_index__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_collections_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_collections_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_collections_lists__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_collections_lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_collections_lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_resume_index__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_resume_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_resume_index__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_index___default.a
  }, {
    path: '/works',
    component: __WEBPACK_IMPORTED_MODULE_3__views_works_index___default.a
  }, {
    path: '/collections',
    component: __WEBPACK_IMPORTED_MODULE_4__views_collections_index___default.a,
    children: [{
      path: '',
      redirect: 'article'
    }, {
      path: ':type',
      component: __WEBPACK_IMPORTED_MODULE_5__views_collections_lists___default.a
    }]
  }, {
    path: '/resume',
    component: __WEBPACK_IMPORTED_MODULE_6__views_resume_index___default.a
  }]
}));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(192),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAVS; });

var NAVS = [{
  name: '主页',
  url: '/home',
  icon: '&#xe638;'
}, {
  name: '撸码笔记',
  url: '/notes',
  icon: '&#xe616;'
}, {
  name: '作品集',
  url: '/works',
  icon: '&#xe68d;'
}, {
  name: '我的收藏',
  url: '/collections',
  icon: '&#xe696;'
}, {
  name: '个人简历',
  url: '/resume',
  icon: '&#xe707;'
}];

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(47);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(12);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showMessageBoard", function() { return showMessageBoard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideMessageBoard", function() { return hideMessageBoard; });


var showMessageBoard = function showMessageBoard(_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SHOW_MESSAGE_BOARD */]);
};

var hideMessageBoard = function hideMessageBoard(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* HIDE_MESSAGE_BOARD */]);
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(12);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showQRCode", function() { return showQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideQRCode", function() { return hideQRCode; });


var showQRCode = function showQRCode(_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* SHOW_REWARD_QR_CODE */]);
};

var hideQRCode = function hideQRCode(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* HIDE_REWARD_QR_CODE */]);
};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_message_board__ = __webpack_require__(53);


var _mutations;




var state = {
  isShow: false
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SHOW_MESSAGE_BOARD */], function (state) {
  state.isShow = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* HIDE_MESSAGE_BOARD */], function (state) {
  state.isShow = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions_message_board__
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_reward_qr_code__ = __webpack_require__(54);


var _mutations;




var state = {
  isShow: false
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SHOW_REWARD_QR_CODE */], function (state) {
  state.isShow = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* HIDE_REWARD_QR_CODE */], function (state) {
  state.isShow = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions_reward_qr_code__
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var self = {};

function set(obj, key, oldValue, targetValue) {
  var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1000;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var d = targetValue - oldValue;
    var step = d / (time / 16);
    obj[key] = oldValue - 0;(function handle() {
      self['frameId' + key] = requestAnimationFrame(handle);
      obj[key] = obj[key] - 0 + step;
      if (Math.abs(obj[key] - targetValue) <= Math.abs(step)) {
        obj[key] = targetValue;
        cancelAnimationFrame(self['frameId' + key]);
        resolve();
      }
    })();
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({ set: set });

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_topbar_topbar__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_topbar_topbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_topbar_topbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_svg_filter_svg_filter__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_svg_filter_svg_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_svg_filter_svg_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_float_buttons_float_buttons__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_float_buttons_float_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_float_buttons_float_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_message_board_message_board__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_message_board_message_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_message_board_message_board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reward_qr_code_reward_qr_code__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reward_qr_code_reward_qr_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_reward_qr_code_reward_qr_code__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    Topbar: __WEBPACK_IMPORTED_MODULE_0__components_topbar_topbar___default.a,
    SvgFilter: __WEBPACK_IMPORTED_MODULE_1__components_svg_filter_svg_filter___default.a,
    FloatButtons: __WEBPACK_IMPORTED_MODULE_2__components_float_buttons_float_buttons___default.a,
    MessageBoard: __WEBPACK_IMPORTED_MODULE_3__components_message_board_message_board___default.a,
    RewardQRCode: __WEBPACK_IMPORTED_MODULE_4__components_reward_qr_code_reward_qr_code___default.a
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_text__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animate_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animate_text__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnimateText',

  props: {
    value: null,

    time: {
      type: Number,
      default: 500
    },

    isNumber: {
      type: Boolean,
      default: false
    },

    startNumber: {
      type: Number,
      default: 0
    },

    changeCount: {
      type: Number,
      default: 32
    }
  },

  data: function data() {
    return {
      animateText: null,
      ready: false
    };
  },


  watch: {
    value: function value(val) {
      var _this = this;

      this.ready = false;
      setTimeout(function () {
        _this.init();
      }, 30);
    },
    time: function time(val) {
      this.animateText ? this.animateText.play(val) : this.init();
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      if (!this.value && this.value - 0 !== 0) return;
      this.ready = true;
      this.animateText = new __WEBPACK_IMPORTED_MODULE_0_animate_text___default.a(this.$el, {
        time: this.time,
        isNumber: this.isNumber,
        startNumber: this.startNumber,
        changeCount: this.changeCount,
        onAnimated: this.onAnimated });
    },
    onAnimated: function onAnimated() {
      this.$emit('animated');
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Book',

  props: {
    defaultPageNumber: {
      type: Number,
      default: 1
    }
  },

  data: function data() {
    return {
      currentShowPageCount: 0
    };
  },


  computed: {
    pageSlotCount: function pageSlotCount() {
      var pageNames = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$slots).filter(function (slotName) {
        return slotName.indexOf('page') === 0;
      });
      var pageSlotCount = pageNames.length;
      if (pageSlotCount % 2 !== 0) {
        console.warn('slot="pageXXX"的数量必须是双数, 否则最后一个将被自动丢弃');
      }
      return pageSlotCount;
    },
    pageCount: function pageCount() {
      return parseInt((this.pageSlotCount - 2) / 2);
    }
  },

  mounted: function mounted() {
    this.playInitAnimation();
  },


  methods: {
    playInitAnimation: function playInitAnimation() {
      var _this = this;

      if (this.defaultPageNumber > this.pageSlotCount) {
        return console.warn('\u9ED8\u8BA4\u9875\u7801' + this.defaultPageNumber + '\u4E0D\u5408\u6CD5, \u8D85\u8FC7\u9875\u9762\u603B\u6570');
      }
      if (this.defaultPageNumber < 1) {
        return console.warn('\u9ED8\u8BA4\u9875\u7801' + this.defaultPageNumber + '\u4E0D\u5408\u6CD5, \u8D85\u8FC7\u9875\u9762\u603B\u6570');
      }

      var targetPageCount = parseInt((this.defaultPageNumber + 1) / 2);

      this.currentShowPageCount = parseInt((this.pageSlotCount + 1) / 2);

      this.playInitAnimationTid = setInterval(function () {
        _this.currentShowPageCount--;
        if (_this.currentShowPageCount === targetPageCount) {
          window.clearInterval(_this.playInitAnimationTid);
        }
      }, 150);
    },
    getPageStyle: function getPageStyle(pageNumber) {
      var transform = '';
      if (pageNumber >= this.currentShowPageCount) {
        transform = 'rotateY(' + (179 - (this.pageCount - pageNumber) / 10) + 'deg)';
      } else {
        transform = 'rotateY(' + pageNumber / 10 + 'deg)';
      }
      return { transform: transform };
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Button',

  props: {
    type: {
      type: String,
      default: 'ghost'
    }
  },

  computed: {
    rootClass: function rootClass() {
      return this.type;
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MenuButton',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      state: 1
    };
  },


  computed: {
    rootClassName: function rootClassName() {
      return this.open ? 'close' : 'open';
    }
  },

  methods: {
    toggle: function toggle() {
      this.$emit('changed', !this.open);
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FloatButtons',

  data: function data() {
    return {
      buttons: [{
        name: 'message',
        label: '留言'
      }]
    };
  },


  methods: {
    onMessageButtonClick: function onMessageButtonClick() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('showMessageBoard');
    },
    onRewardButtonClick: function onRewardButtonClick() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('showQRCode');
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_browser__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_animation_data__ = __webpack_require__(57);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HeaderImage',

  data: function data() {
    return {
      show: true,
      showingRipple: false
    };
  },


  computed: {
    canShowRipple: function canShowRipple() {
      var result = !__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.messageBoard.isShow && !__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.rewardQRCode.isShow && !__WEBPACK_IMPORTED_MODULE_2__utils_browser___default.a.versions.mobile;
      return result;
    }
  },

  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    window.clearInterval(this.rippleTimeId);
  },


  methods: {
    showSvgRipple: function showSvgRipple(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var turb, width, height, oldX, oldY, time, setX, setY, setW, setH;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.canShowRipple) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!_this.showingRipple) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _this.showingRipple = true;

                turb = document.querySelector('#filter-ripple feImage');
                width = 800;
                height = 800;
                oldX = e.offsetX;
                oldY = e.offsetY;
                time = 1200;
                setX = __WEBPACK_IMPORTED_MODULE_4__utils_animation_data__["a" /* default */].set(turb.attributes.x, 'value', oldX, oldX - width / 2, time);
                setY = __WEBPACK_IMPORTED_MODULE_4__utils_animation_data__["a" /* default */].set(turb.attributes.y, 'value', oldY, oldY - height / 2, time);
                setW = __WEBPACK_IMPORTED_MODULE_4__utils_animation_data__["a" /* default */].set(turb.attributes.width, 'value', 0, width, time);
                setH = __WEBPACK_IMPORTED_MODULE_4__utils_animation_data__["a" /* default */].set(turb.attributes.height, 'value', 0, height, time);
                _context.next = 17;
                return setX;

              case 17:
                _context.next = 19;
                return setY;

              case 19:
                _context.next = 21;
                return setW;

              case 21:
                _context.next = 23;
                return setH;

              case 23:
                setTimeout(function () {
                  turb.attributes.x.value = oldX;
                  turb.attributes.y.value = oldY;
                  turb.attributes.width.value = 0;
                  turb.attributes.height.value = 0;
                  _this.showingRipple = false;
                }, 300);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logo'
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MessageBoard',

  computed: {
    show: function show() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.messageBoard.isShow;
    }
  },

  mounted: function mounted() {
    this.initMessageBoard();
  },


  methods: {
    initMessageBoard: function initMessageBoard() {
      var script = void 0;
      var ID = 'changyan-script';
      script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('charset', 'utf-8');
      script.setAttribute('src', 'https://changyan.sohu.com/upload/changyan.js');
      script.setAttribute('id', ID);
      document.body.appendChild(script);
      script.onload = this.messageBoardOnload;
    },
    messageBoardOnload: function messageBoardOnload() {
      window.changyan.api.config({
        appid: 'cysYtxn7z',
        conf: 'prod_3b9c222885e32e14c78058850a4cc0c5'
      });
    },
    hide: function hide() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('hideMessageBoard');
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(11);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RewardQRCode',

  data: function data() {
    return {
      payType: 'wechat'
    };
  },


  computed: {
    show: function show() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.rewardQRCode.isShow;
    }
  },

  mounted: function mounted() {},


  methods: {
    togglePayType: function togglePayType() {
      this.payType = this.payType === 'wechat' ? 'alipay' : 'wechat';
    },
    hideQRCode: function hideQRCode() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('hideQRCode');
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_browser__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_browser__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SvgFilter',

  data: function data() {
    return {
      show: __WEBPACK_IMPORTED_MODULE_0__utils_browser___default.a.versions.aaa
    };
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_image_header_image__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_image_header_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_image_header_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_browser__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_browser__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Topbar',

  components: {
    HeaderImage: __WEBPACK_IMPORTED_MODULE_0__components_header_image_header_image___default.a
  },

  data: function data() {
    return {
      isOpenMenu: false,
      enterMenuBtn: false,

      moveFilterStyle: __WEBPACK_IMPORTED_MODULE_2__utils_browser___default.a.versions.chrome ? 'x' : '',

      menus: []
    };
  },


  computed: {
    currentPath: function currentPath() {
      return this.$route.path;
    },
    orderMenus: function orderMenus() {
      var _this = this;

      var menus = this.menus;
      var result = [];
      menus.forEach(function (menu) {
        var isCurrentMenu = _this.currentPath.indexOf(menu.url) === 0;
        isCurrentMenu ? result.unshift(menu) : result.push(menu);
      });
      return result;
    }
  },

  watch: {
    currentPath: function currentPath() {}
  },

  mounted: function mounted() {},


  methods: {
    toggleMenuState: function toggleMenuState(state) {
      var _this2 = this;

      this.isOpenMenu = state;

      this.menus = [];
      var currentMenus = [];
      window.clearInterval(this.intervalId);
      if (this.isOpenMenu) {
        this.intervalId = setInterval(function () {
          var newMenu = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* NAVS */][currentMenus.length];
          if (!newMenu) return window.clearInterval(_this2.intervalId);
          currentMenus.push(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* NAVS */][currentMenus.length]);
          _this2.menus = currentMenus;
        }, 100);
      }
    },
    onMenuMouseLeave: function onMenuMouseLeave() {
      var _this3 = this;

      setTimeout(function () {
        if (_this3.enterMenuBtn) return;
        _this3.toggleMenuState(false);
      }, 50);
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var NAVS = [{
  label: '干货',
  name: 'article'
}, {
  label: '文档',
  name: 'docs'
}, {
  label: '工具库',
  name: 'tool'
}, {
  label: '鉴赏',
  name: 'appreciation'
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Navs',

  data: function data() {
    return {
      navs: NAVS
    };
  },


  computed: {
    type: function type() {
      return this.$route.params.type;
    },
    selectedNav: function selectedNav() {
      var _this = this;

      var result = {};
      this.navs.forEach(function (nav) {
        nav.name === _this.type && (result = nav);
      });
      return result;
    }
  },

  methods: {
    onSelectNav: function onSelectNav(nav) {
      this.$router.push(nav.name);
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Title',

  props: {
    title: {
      type: String,
      default: 'Collections'
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_title__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navs__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_navs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_navs__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Collections',

  components: {
    XTitle: __WEBPACK_IMPORTED_MODULE_0__components_title___default.a,
    Navs: __WEBPACK_IMPORTED_MODULE_1__components_navs___default.a
  },

  data: function data() {
    return {
      title: 'Collections'
    };
  },


  methods: {}
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'List',

  data: function data() {
    return {
      lists: [{
        title: '标题标题标题标题标题标题标题标题',
        content: '内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容'
      }, {
        title: '标题标题标题标题标题标题标题标题',
        content: '内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容'
      }]
    };
  },


  computed: {
    type: function type() {
      return this.$route.params.type;
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_browser__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_browser__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Background',

  props: {
    maskOpacity: {
      type: Number,
      default: 0.4
    }
  },

  data: function data() {
    return {
      position: {
        x: 50,
        y: 50
      }
    };
  },


  computed: {
    backgroundStyle: function backgroundStyle() {
      var result = {
        backgroundPositionX: this.position.x + '%',
        backgroundPositionY: this.position.y + '%'
      };
      return result;
    },
    maskStyle: function maskStyle() {
      var result = {
        opacity: this.maskOpacity
      };
      return result;
    }
  },

  mounted: function mounted() {
    !__WEBPACK_IMPORTED_MODULE_0__utils_browser___default.a.versions.mobile && __WEBPACK_IMPORTED_MODULE_0__utils_browser___default.a.versions.mac && __WEBPACK_IMPORTED_MODULE_0__utils_browser___default.a.versions.chrome && this.addEventListener();
  },
  beforeDestroy: function beforeDestroy() {
    this.mousemoveEvent && document.removeEventListener('mousemove', this.mousemoveEvent);
  },


  methods: {
    addEventListener: function addEventListener() {
      var _this = this;

      var time = 200;
      var open = true;
      var _document$body = document.body,
          clientWidth = _document$body.clientWidth,
          clientHeight = _document$body.clientHeight;

      document.addEventListener('mousemove', this.mousemoveEvent = function (e) {
        if (!open) return;
        var pageX = e.pageX,
            pageY = e.pageY;

        var x = 50 + (pageX - clientWidth / 2) / clientWidth * 10;
        var y = 50 + (pageY - clientHeight / 2) / clientHeight * 100;
        _this.position.x = x;
        _this.position.y = y;
        setTimeout(function () {
          open = true;
        }, time);
        open = false;
      });
    }
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_background__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_background__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',

  components: {
    Background: __WEBPACK_IMPORTED_MODULE_0__components_background___default.a
  },

  data: function data() {
    return {
      message: {
        name: '邱国辉',
        descriptions: 'It is because of dream, you become a great man.',
        github: 'https://github.com/qgh810'
      }
    };
  },


  methods: {
    goGitbug: function goGitbug(url) {
      window.open(url);
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Page2',

  data: function data() {
    return {
      messages: __WEBPACK_IMPORTED_MODULE_0__data__["d" /* MESSAGES */]
    };
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data__ = __webpack_require__(19);





var PAGE_NUMBER = 3;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Page' + PAGE_NUMBER,

  data: function data() {
    return {
      selectedLabel: null,
      labels: __WEBPACK_IMPORTED_MODULE_1__data__["b" /* LABELS */],
      positions: __WEBPACK_IMPORTED_MODULE_1__data__["c" /* POSITIONS */]
    };
  },


  computed: {
    currentShowPageNumbers: function currentShowPageNumbers() {
      var currentPageNumber = this.$parent.currentShowPageCount * 2;
      return [currentPageNumber - 1, currentPageNumber];
    },
    currentPageShowwing: function currentPageShowwing() {
      return this.currentShowPageNumbers.indexOf(PAGE_NUMBER) >= 0;
    },
    currentLabel: function currentLabel() {
      return this.selectedLabel || this.labels[0];
    },
    currentLabelIndex: function currentLabelIndex() {
      return this.labels.indexOf(this.currentLabel);
    }
  },

  watch: {
    currentPageShowwing: function currentPageShowwing(val) {
      var _this = this;

      if (val) {
        this.initAnimationTid = setTimeout(function () {
          _this.shuffle();
        }, 300);
      } else {
        window.clearInterval(this.initAnimationTid);
      }
    }
  },

  methods: {
    onSelectLabel: function onSelectLabel(label) {
      this.selectedLabel = label;
    },
    shuffle: function shuffle() {
      var _POSITIONS = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(__WEBPACK_IMPORTED_MODULE_1__data__["c" /* POSITIONS */]),
          positions = _POSITIONS.slice(0);

      positions.sort(function (a, b) {
        return Math.random() > 0.5 ? -1 : 1;
      });
      this.positions = positions;
    },
    getLabelStyle: function getLabelStyle(label, index) {
      var isCurrentLabel = this.currentLabel === label;
      var style = {
        color: label.style.color,
        fontSize: label.style.fontSize,
        left: isCurrentLabel ? '0' : this.positions[index].left,
        top: isCurrentLabel ? '0' : this.positions[index].top
      };
      return style;
    }
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data__ = __webpack_require__(19);



var PAGE_NUMBER = 4;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Page' + PAGE_NUMBER,

  data: function data() {
    return {
      isShowText: false
    };
  },


  computed: {
    currentShowPageNumbers: function currentShowPageNumbers() {
      var currentPageNumber = this.$parent.currentShowPageCount * 2;
      return [currentPageNumber - 1, currentPageNumber];
    },
    currentPageShowwing: function currentPageShowwing() {
      return this.currentShowPageNumbers.indexOf(PAGE_NUMBER) >= 0;
    },
    selectLabel: function selectLabel() {
      var result = this.$parent.$slots.page3[0].componentInstance.currentLabel.name;
      return result;
    },
    currentLabelMessage: function currentLabelMessage() {
      return __WEBPACK_IMPORTED_MODULE_0__data__["a" /* LABEL_DETAILS */][this.selectLabel];
    },
    logoClassName: function logoClassName() {
      return this.selectLabel.split('/')[0].split('.')[0];
    }
  },

  watch: {
    currentPageShowwing: function currentPageShowwing(val) {
      val && this.playTextAnimation(1000);
    },
    selectLabel: function selectLabel() {
      this.playTextAnimation(1000);
    }
  },

  mounted: function mounted() {},


  methods: {
    playTextAnimation: function playTextAnimation() {
      var _this = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.isShowText = false;
      window.clearTimeout(this.playTextAnimationTid);
      this.playTextAnimationTid = setTimeout(function () {
        _this.isShowText = true;
      }, time);
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_page1__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_page1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_page1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_page2__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_page2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_page2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_page3__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_page3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_page3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_page4__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_page4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_page4__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Resume',

  components: {
    Page1: __WEBPACK_IMPORTED_MODULE_0__components_page1___default.a,
    Page2: __WEBPACK_IMPORTED_MODULE_1__components_page2___default.a,
    Page3: __WEBPACK_IMPORTED_MODULE_2__components_page3___default.a,
    Page4: __WEBPACK_IMPORTED_MODULE_3__components_page4___default.a
  },

  data: function data() {
    return {
      isShowTitle: false,
      isShowBook: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShowTitle = true;
    }, 200);
    setTimeout(function () {
      _this.isShowBook = true;
    }, 1000);
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Works',

  mounted: function mounted() {},


  methods: {}
});

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-image2.3274074.jpg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.528ed50.png";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(185),
  /* scopeId */
  "data-v-3c07aa44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(142)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(194),
  /* scopeId */
  "data-v-74440c44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(143)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(195),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(141)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(193),
  /* scopeId */
  "data-v-6fe7cede",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(180),
  /* scopeId */
  "data-v-1fe59e06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(187),
  /* scopeId */
  "data-v-59770d84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(127)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(179),
  /* scopeId */
  "data-v-1e8054f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(131)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(183),
  /* scopeId */
  "data-v-3557c326",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(126)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(178),
  /* scopeId */
  "data-v-14e21e04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(124)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(176),
  /* scopeId */
  "data-v-00bec544",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(182),
  /* scopeId */
  "data-v-323e02b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  "data-v-8f4928a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  "data-v-ce43fef0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(147)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(144)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(196),
  /* scopeId */
  "data-v-7f36f8fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(186),
  /* scopeId */
  "data-v-57f4a086",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(191),
  /* scopeId */
  "data-v-5ed796e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(190),
  /* scopeId */
  "data-v-5ebb67e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(189),
  /* scopeId */
  "data-v-5e9f38e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(188),
  /* scopeId */
  "data-v-5e8309e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(132)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(184),
  /* scopeId */
  "data-v-3b9fb01f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(129)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(181),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "svg-filters-root"
  }, [(_vm.show) ? _c('svg', {
    staticClass: "svg-filters-root",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "filter-blur-x",
      "x": "-20%",
      "y": "0",
      "width": "140%",
      "height": "100%"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "in": "SourceGraphic",
      "stdDeviation": "12,0"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter-blur-y",
      "x": "0",
      "y": "20%",
      "width": "100%",
      "height": "140%"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "in": "SourceGraphic",
      "stdDeviation": "0,20"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-root"
  }, [_c('background'), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('logo'), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.message.name))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_c('animate-text', {
    attrs: {
      "value": _vm.message.descriptions,
      "time": 1000
    }
  })], 1), _vm._v(" "), _c('p', [_c('h-button', {
    staticClass: "link",
    nativeOn: {
      "click": function($event) {
        _vm.goGitbug(_vm.message.github)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v("  github")])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "reward-qr-code-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "reward-qr-code-root",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.hideQRCode($event)
      }
    }
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("打赏")])]), _vm._v(" "), _c('div', {
    staticClass: "nonsense"
  }, [_c('span', [_vm._v("如果觉得我的网站对您有用，请随意打赏。"), _c('br'), _vm._v("您的支持将鼓励我继续创作！")])]), _vm._v(" "), _c('div', {
    staticClass: "qr-code-box"
  }, [_c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [(_vm.payType === 'alipay') ? _c('div', {
    key: _vm.payType,
    staticClass: "qr-code alipay"
  }) : _vm._e(), _vm._v(" "), (_vm.payType === 'wechat') ? _c('div', {
    key: _vm.payType,
    staticClass: "qr-code wechat"
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "toggle-button-box"
  }, [_c('i', {
    staticClass: "iconfont wechat"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-button",
    class: _vm.payType,
    on: {
      "click": _vm.togglePayType
    }
  }, [_c('div', {
    staticClass: "circle"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payType === 'wechat'),
      expression: "payType==='wechat'"
    }],
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payType === 'alipay'),
      expression: "payType==='alipay'"
    }],
    staticClass: "iconfont"
  }, [_vm._v("")])])]), _vm._v(" "), _c('i', {
    staticClass: "iconfont alipay"
  }, [_vm._v("")])])])])])
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-root"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(152),
      "alt": "logo",
      "width": "100%",
      "height": "100%"
    }
  })])
}]}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-buttons-root"
  }, [_c('div', {
    staticClass: "icon-box message",
    on: {
      "click": _vm.onMessageButtonClick
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "icon-box reward",
    on: {
      "click": _vm.onRewardButtonClick
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])])])
},staticRenderFns: []}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "works-roots"
  }, [_vm._v("\n  我的作品\n")])
},staticRenderFns: []}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar-root"
  }, [_c('div', {
    staticClass: "menu-btn-box",
    on: {
      "mouseenter": function($event) {
        _vm.enterMenuBtn = true
      },
      "mouseleave": function($event) {
        _vm.enterMenuBtn = false
      }
    }
  }, [_c('menu-button', {
    attrs: {
      "open": _vm.isOpenMenu
    },
    on: {
      "changed": _vm.toggleMenuState
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-container-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpenMenu),
      expression: "isOpenMenu"
    }],
    staticClass: "menu-container",
    class: {
      open: _vm.isOpenMenu
    },
    on: {
      "mouseleave": _vm.onMenuMouseLeave
    }
  }, [_c('header-image'), _vm._v(" "), _c('div', {
    staticClass: "menus"
  }, [_c('transition-group', {
    attrs: {
      "name": "menu-transition",
      "tag": "nav"
    }
  }, _vm._l((_vm.orderMenus), function(menu) {
    return _c('div', {
      key: menu.name,
      staticClass: "menu",
      class: ("filter-" + _vm.moveFilterStyle)
    }, [_c('router-link', {
      attrs: {
        "to": menu.url
      }
    }, [_c('i', {
      staticClass: "iconfont",
      domProps: {
        "innerHTML": _vm._s(menu.icon)
      }
    }), _vm._v("\n              " + _vm._s(menu.name) + "\n            ")])], 1)
  }))], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "message-board-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "message-board-root"
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "comment-container"
  }, [_c('div', {
    attrs: {
      "id": "SOHUCS",
      "sid": "homepage"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-roots"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "title",
    class: {
      hide: !_vm.isShowTitle
    }
  }, [_c('span', [_vm._v("RESUME")])]), _vm._v(" "), (_vm.isShowBook) ? _c('book', {
    attrs: {
      "defaultPageNumber": 3
    }
  }, [_c('page1', {
    slot: "page1"
  }), _vm._v(" "), _c('page2', {
    slot: "page2"
  }), _vm._v(" "), _c('page3', {
    slot: "page3"
  }), _vm._v(" "), _c('page4', {
    slot: "page4"
  }), _vm._v(" "), _c('div', {
    staticClass: "first",
    slot: "page5"
  }, [_vm._v("555")]), _vm._v(" "), _c('div', {
    staticClass: "first",
    slot: "page6"
  }, [_vm._v("666")]), _vm._v(" "), _c('div', {
    staticClass: "first",
    slot: "page7"
  }, [_vm._v("777")]), _vm._v(" "), _c('div', {
    staticClass: "first",
    slot: "page8"
  }, [_vm._v("...")]), _vm._v(" "), _c('div', {
    slot: "page9"
  }), _vm._v(" "), _c('div', {
    slot: "page10"
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "x-animate-text-root",
    class: {
      'x-animate-text-hidden': !_vm.ready
    },
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-root"
  }, [_c('div', {
    staticClass: "background",
    style: (_vm.backgroundStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "mask",
    style: (_vm.maskStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-image-root"
  }, [(_vm.canShowRipple) ? _c('svg', {
    staticClass: "svg-filters",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "filter-ripple"
    }
  }, [_c('feImage', {
    attrs: {
      "xlink:href": "../static/images/ripple.png",
      "x": "30",
      "y": "20",
      "width": "0",
      "height": "0",
      "result": "ripple"
    }
  }), _vm._v(" "), _c('feDisplacementMap', {
    attrs: {
      "xChannelSelector": "R",
      "yChannelSelector": "G",
      "color-interpolation-filters": "sRGB",
      "in": "SourceGraphic",
      "in2": "ripple",
      "scale": "20",
      "result": "dm"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "operator": "in",
      "in2": "ripple"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "SourceGraphic"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "header-image-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "header-image",
    on: {
      "mouseenter": _vm.showSvgRipple,
      "mousedown": _vm.showSvgRipple
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(151),
      "alt": "header-image",
      "width": "100%",
      "height": "100%"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-root"
  }, [_c('div', {
    staticClass: "container-box logo-box"
  }, [_c('div', {
    staticClass: "logo",
    class: _vm.logoClassName
  })]), _vm._v(" "), _c('div', {
    staticClass: "container-box name-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "container-box text-box"
  }, [(_vm.isShowText) ? _c('animate-text', {
    attrs: {
      "value": _vm.currentLabelMessage.message
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-root"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "label-wall",
    on: {
      "click": _vm.shuffle
    }
  }, [_c('div', {
    staticClass: "center-box"
  }, [_vm._l((_vm.labels), function(label, index) {
    return _c('div', {
      key: label,
      staticClass: "label",
      style: (_vm.getLabelStyle(label, index)),
      on: {
        "click": function($event) {
          _vm.onSelectLabel(label)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(label.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "selected-icon"
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-box"
  }, [_c('span', [_vm._v("技术栈")]), _vm._v(" "), _c('p', [_vm._v("已经掌握或者基本掌握的技术名称")])])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-root"
  }, [_c('div', {
    staticClass: "message-box"
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      staticClass: "message"
    }, [_c('div', {
      staticClass: "icon-box"
    }, [_c('i', {
      staticClass: "iconfont",
      domProps: {
        "innerHTML": _vm._s(message.icon)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v(_vm._s(message.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', [_vm._v(_vm._s(message.content))])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-root"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('div', {
    staticClass: "header-image"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name-box"
  }, [_c('span', [_vm._v("邱国辉")])]), _vm._v(" "), _c('div', {
    staticClass: "message-box"
  }, [_c('p', [_c('span', [_vm._v("WEB前端工程师")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("530784837@qq.com")])])])])
}]}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('topbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "page-transition",
      "mode": "in-out"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('float-buttons'), _vm._v(" "), _c('message-board'), _vm._v(" "), _c('reward-q-r-code')], 1)
},staticRenderFns: []}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-button-root",
    class: _vm.rootClassName,
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "line line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line3"
  })])
},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-root"
  }, [_c('div', {
    staticClass: "pages-container"
  }, [_c('div', {
    staticClass: "page",
    style: ({
      transform: 'rotateY(0deg)'
    })
  }, [_c('div', {
    staticClass: "front"
  }, [_vm._t("page1", [_vm._v("\n          首页\n        ")])], 2)]), _vm._v(" "), _vm._l((_vm.pageCount), function(n) {
    return _c('div', {
      staticClass: "page",
      style: (_vm.getPageStyle(n))
    }, [_c('div', {
      staticClass: "front"
    }, [_vm._t(("page" + (n * 2 + 1)), [_vm._v("\n          页码" + _vm._s(n * 2) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control",
      on: {
        "click": function($event) {
          _vm.currentShowPageCount--
        }
      }
    }, [_c('span', [_vm._v("prev")])])], 2), _vm._v(" "), _c('div', {
      staticClass: "back"
    }, [_vm._t(("page" + (n * 2)), [_vm._v("\n          页码" + _vm._s(n * 2 - 1) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "control",
      on: {
        "click": function($event) {
          _vm.currentShowPageCount++
        }
      }
    }, [_c('span', [_vm._v("next")])])], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "page",
    style: ({
      transform: 'rotateY(180deg)'
    })
  }, [_c('div', {
    staticClass: "back"
  }, [_vm._t(("page" + _vm.pageSlotCount), [_vm._v("\n          尾页\n        ")])], 2)])], 2)])
},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button-root",
    class: _vm.rootClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-root"
  }, [_c('div', {
    staticClass: "list-box"
  }, _vm._l((_vm.lists), function(ref) {
    var title = ref.title;
    var content = ref.content;

    return _c('div', {
      staticClass: "list"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v(_vm._s(title))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', [_vm._v(_vm._s(content))])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navs"
  }, _vm._l((_vm.navs), function(nav) {
    return _c('div', {
      staticClass: "nav",
      class: {
        selected: _vm.selectedNav === nav
      },
      on: {
        "click": function($event) {
          _vm.onSelectNav(nav)
        }
      }
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(nav.label))]), _vm._v(" "), _c('span', {
      staticClass: "line top"
    }), _vm._v(" "), _c('span', {
      staticClass: "line bottom"
    })])
  }))
},staticRenderFns: []}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collections-roots"
  }, [_c('x-title'), _vm._v(" "), _c('navs'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[52]);


// WEBPACK FOOTER //
// static/js/app.df1e9df5e9279e9770e3.js